import { cacheservice } from '../../../../config/cacheservice';

export const dataValidationTotalIncomeCheck = (data, stageID) => {
    console.log('updatedData', data);
    let returnValue = [];

    data.checklistJson.checklistL1.questions.map((question, index) => {
        // console.log('bbbbbb',question)
        let subQuestionReturnValue = [];

        if (question.sectionText == 'Does your total income exceed Rs 50Lakhs?') {
            question.subQuestion.map((subQuestion, index) => {
                if (subQuestion.sectionText == 'Details of immovable assets') {
                    subQuestionReturnValue.push({
                        sectionText: 'Details of immovable assets',
                        decession: crcChecker(subQuestion.fields, stageID, subQuestion),
                    });
                }
                if (subQuestion.sectionText == 'Details of movable seat') {
                    subQuestionReturnValue.push({
                        sectionText: 'Details of movable seat',
                        decession: crcChecker(subQuestion.fields, stageID, subQuestion),
                    });
                }
                if (subQuestion.sectionText == 'Whether you have held unlisted equity shares at any time during the previous year') {
                    subQuestionReturnValue.push({
                        sectionText: 'Whether you have held unlisted equity shares at any time during the previous year',
                        decession: crcChecker(subQuestion.fields, stageID, subQuestion),
                    });
                }
                if (
                    subQuestion.sectionText ==
                    'Interest held in the assets of a firm or association of persons (AOP) as a partner or member thereof'
                ) {
                    subQuestionReturnValue.push({
                        sectionText: 'Interest held in the assets of a firm or association of persons (AOP) as a partner or member thereof',
                        decession: crcChecker(subQuestion.fields, stageID, subQuestion),
                    });
                }
                if (subQuestion.sectionText == 'Liabilities(if any) relating to the above assets at A,B and C') {
                    subQuestionReturnValue.push({
                        sectionText: 'Liabilities(if any) relating to the above assets at A,B and C',
                        decession: crcChecker(subQuestion.fields, stageID, subQuestion),
                    });
                }
                if (subQuestion.sectionText == 'Total income Radio') {
                    subQuestionReturnValue.push({
                        sectionText: 'Total income Radio',
                        decession: crcChecker(subQuestion.fields, stageID, subQuestion),
                    });
                }
            });
            returnValue[index] = subQuestionReturnValue;
        }
    });
    return AMIrrelavantAcordingList(returnValue);
};

const crcChecker = (questions, stageID, fullQuestions, optionalQuestions) => {
    return fieldChecker(questions, optionalQuestions, fullQuestions);
};

const fieldChecker = (fieldCheckerArray, optionalFieldChekerArray, fieldValue) => {
    if (optionalFieldChekerArray && optionalFieldChekerArray.length) {
        fieldCheckerArray = fieldCheckerArray.filter((val) => !optionalFieldChekerArray.some((ele) => ele === val.fieldName));
    }
    if (fieldValue && fieldValue.sectionText === 'additionalQuestion') {
        fieldCheckerArray = fieldCheckerArray.filter((val) => val.relevanceResponseAM !== 'uploadFile');
    }
    if (fieldCheckerArray.length > 0) {
        for (let i = 0; i < fieldCheckerArray.length; i++) {
            if (fieldCheckerArray[i].response !== '') {
                return false;
            }
        }
    }
    return true;
};

const AMIrrelavantAcordingList = (decessionArray) => {
    let irrevelentFieldContainer;
    for (let i = 0; i < decessionArray.length; i++) {
        if (decessionArray[i] && decessionArray[i].length) {
            irrevelentFieldContainer = decessionArray[i].filter(function (value) {
                return value.decession === false;
            }).length;
        }
    }
    cacheservice.sendTotalIncomeCount(irrevelentFieldContainer);
    console.log(irrevelentFieldContainer);
    return irrevelentFieldContainer;
};
